import React from 'react';
import classnames from 'classnames';
import { InlineIcon } from '../../inline-icon/inline-icon';
import ArrowRightIcon from '../../../icons/compiled/components/ArrowRightIcon';
import styles from './button.scss';
export const NavButton = ({ onClick, arrowIcon, className, ariaLabel, dataHook, tabIndex, style, }) => (React.createElement("button", { onClick: onClick, style: style, type: "button", className: classnames(className, styles.button), tabIndex: tabIndex, "aria-label": ariaLabel, "data-hook": dataHook }, arrowIcon));
NavButton.defaultProps = {
    arrowIcon: React.createElement(InlineIcon, { icon: React.createElement(ArrowRightIcon, null) }),
    tabIndex: 0,
};
//# sourceMappingURL=button.js.map